<template>

<div class="row">
    
    <div class="col-12">
        <h1>OFMDB.com</h1>
    </div>

    <div class='col-12'>
    	

    </div>

</div>

</template>

<script>
    export default {
        
        mounted() {

        }

    }
</script>
